export const accept_terms_of_use = `mutation accept_terms_of_use($input: Int!){
    accept_terms_of_use(input: $input)
}`;
